var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t_panel"},[_c('header',{staticClass:"Panel-header"},[_vm._t("header")],2),_c('main',{staticClass:"Panel-main"},[_vm._t("default")],2),_c('footer',{staticClass:"Panel-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }